import { partnerConnectConnector } from "partner-connect/server/connectors/partner-connect-connector";
import { DebugTab } from "slotworks/debug/menu/tabs/debug-tab";

export class PartnerConnectForceTab extends DebugTab {

    public render(root: HTMLElement, hide: Function) {
        this.resultList.getList().then((list: string[]) => {
            const header = document.createElement("h1");
            header.style.fontSize = "2vw";
            header.style.width = "76vw";
            header.style.color = "white";
            header.style.textAlign = "center";
            header.innerText = "Partner Connect Cheats";

            root.appendChild(header);

            const testMode = document.createElement("button");

            testMode.style.fontSize = "1vmax";
            testMode.style.margin = "1vw 1vh";
            testMode.style.borderRadius = "10px";
            testMode.style.width = "63.5vmax";
            testMode.style.height = "10vmax";
            testMode.style.outline = "none";
            testMode.style.cursor = "pointer";
            testMode.style.fontWeight = "bold";
            testMode.style.backgroundColor = `#${(partnerConnectConnector.test) ? "aaffaa" : "ffaaaa"}`;
            testMode.innerText = `Test Mode (${(partnerConnectConnector.test) ? "Enabled" : "Disabled"})`;

            testMode.onclick = () => {
                partnerConnectConnector.test = !partnerConnectConnector.test;
                testMode.innerText = `Test Mode (${(partnerConnectConnector.test) ? "Enabled" : "Disabled"})`;
                testMode.style.backgroundColor = `#${(partnerConnectConnector.test) ? "aaffaa" : "ffaaaa"}`;
            };

            root.appendChild(testMode);

            this.addSeparator(root);

            const textField = document.createElement("textarea");

            textField.style.fontSize = "5vmax";
            textField.style.margin = "1vw 1vh";
            textField.style.borderRadius = "10px";
            textField.style.width = "63.5vmax";
            textField.style.height = "10vmax";
            textField.style.outline = "none";
            textField.style.fontWeight = "bold";
            textField.style.resize = "none";

            textField.oninput = () => {
                textField.value = textField.value.replace(/[^\d,]+/g, "");
            };

            root.appendChild(textField);

            const applyCheat = document.createElement("button");

            applyCheat.style.fontSize = "1vmax";
            applyCheat.style.margin = "1vw 1vh";
            applyCheat.style.borderRadius = "10px";
            applyCheat.style.width = "63.5vmax";
            applyCheat.style.height = "10vmax";
            applyCheat.style.outline = "none";
            applyCheat.style.cursor = "pointer";
            applyCheat.style.fontWeight = "bold";
            applyCheat.innerText = `Apply Cheat`;

            applyCheat.onclick = () => {
                if (textField.value.length > 0) {
                    partnerConnectConnector.cheat = textField.value;
                } else {
                    partnerConnectConnector.cheat = undefined;
                }
                hide();
            };

            root.appendChild(applyCheat);

            this.addSeparator(root);

            // Add buttons
            for (const force of list) {
                this.addResultButton(root, hide, force);
            }
        });
    }
}
